import { NavMenuItem, SideNavWrapper } from 'common/components'
import { ROUTE_PATHS } from 'common/routePaths'

import Admins from './admins/Admins'
import CompanyDetails from './companyDetails'
import Subscription from './subscription'

enum NavigationMapping {
  Details = 1,
  Admins = 2,
  Subscription = 3,
}

const companyNavigationPathMapping = new Map<string, number>([
  ['/', NavigationMapping.Details],
  ['/admins', NavigationMapping.Admins],
  ['/subscription', NavigationMapping.Subscription],
])

const companyNavigationMenu: NavMenuItem[] = [
  {
    name: 'admin-dashboard.company-settings.left-navigation.company-details-title',
    key: NavigationMapping.Details,
    path: '/',
    component: CompanyDetails,
  },
  {
    name: 'admin-dashboard.company-settings.left-navigation.company-admins-title',
    key: NavigationMapping.Admins,
    path: '/admins',
    componentTitle: 'admin-dashboard.company-settings.company-admins.title',
    component: Admins,
  },
  {
    name: 'admin-dashboard.company-settings.left-navigation.subscription-title',
    key: NavigationMapping.Subscription,
    path: '/subscription',
    componentTitle: 'admin-dashboard.company-settings.subscription.title',
    component: Subscription,
  },
]

const CompanySettings = () => {
  return (
    <SideNavWrapper
      title="company-settings"
      rootPath={ROUTE_PATHS.COMPANY_SETTINGS}
      navStartingPositon={NavigationMapping.Details}
      navigationPathMapping={companyNavigationPathMapping}
      navigationMenu={companyNavigationMenu}
    />
  )
}

export default CompanySettings
